// https://material.angular.io/components/table/overview
import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatTableDataSource, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FacturaRegimenFiscal } from '../../models/facturaRegimenFiscal';
import { FacturaFormaPago } from '../../models/facturaFormaPago';
import { FacturaMetodoPago } from '../../models/facturaMetodoPago';
import { FacturaUsoCFDI } from '../../models/facturaUsoCFDI';
import { FacturaUnidadMedida } from '../../models/facturaUnidadMedida';
import { Item } from '../../models/item';
import { Organizacion } from '../../models/organizacion';
import { FacturaDetalle } from '../../models/facturaDetalle';
import { privateEncrypt } from 'crypto';
import { FacturaItem } from '../../models/facturaItem';
import { FacturaItemSAT } from '../../models/facturaItemSAT';
import { Factura, FacturaDocumento } from '../../models/factura';
import { Usuario } from '../../models/usuario';
import { forEach } from 'core-js/fn/array';
import { MatSelect } from '@angular/material/select';
import {modalImpuestosRetendidos} from '../agregar-editar/impuestosRetenidos/impuestosRetenidos.component'
import { Subscription } from 'rxjs/Subscription';
import { fromEvent } from 'rxjs/observable/fromEvent';
import 'rxjs/add/operator/debounceTime';

/**
 * @title Table with pagination
 */
@Component({
  selector: 'my-factura-detalle',
  styleUrls: [],
  templateUrl: 'factura-detalle.component.html',
  providers: [generalService]
})
export class FacturaDetalleComponent {

    public viewDataProd: any[];
    public viewDataProdEdit: any[];
    private itemsShowProd = 10;
    private filteredItemsShowProd = 10;
    private arrayFilteredProd = undefined;
    private isFilteredProd = false;
    private listaProductoEdit: any[];
    @ViewChild('infiniteSelect') selectElem: MatSelect;

    public viewDataSat: any[];
    public viewDataSatEdit: any[];
    private itemsShowSat = 10;
    private filteredItemsShowSat = 10;
    private arrayFilteredSat = undefined;
    private isFilteredSat = false;
    private listaSATCodeEdit: any[];
    @ViewChild('infiniteSelectSat') selectElemSat: MatSelect;

    public matOptions: any;

    factura: Factura = new Factura();
    facturaTipo: number = null;
    idDocuments: string = null;
    price: number = null;
    totalFaltante: number = null;
    ventaDetalleListado: any[] = [];
    facturaAgregar: FormGroup;

    siguiente: boolean = false;
    titulo = 'Agregar';
    id: number = null; // id factura

    listaSucursal: Organizacion[] = [];
    listaRegimenFiscal: FacturaRegimenFiscal[] = [];
    listaFormaPago: FacturaFormaPago[] = [];
    listaMetodoPago: FacturaMetodoPago[] = [];
    listaCFDI: FacturaUsoCFDI[] = [];
    listaSATCode: any[] = [];
    listaCargo: any[] = [];
    listaDataCompany: any[] = [];
    DataImpuestosRetenidos: any = {};
    listaPredial: any[] = [];
    newDataImpuestosRetenidos: any[] = [];

    listaProducto: FacturaItem[] = [];
    
    listaUnidad: FacturaUnidadMedida[] = [];

    subtotal: number = 0;
    impuestos: number = 0;
    total: number = 0;

    public seEstaEditando = false;
    public seEstaAgregando = false;
    public btnGuardar = false;
    public transaccionEnCurso = false;
    listaFacturaDetalle: FacturaDetalle[] = [];
    listaFacturaDetalleAAgregar: FacturaDetalle[] = [];
    public dataSource = new MatTableDataSource<FacturaDetalle>();
    public displayedColumns: string[] = [
      'activo',
      'acciones',
      'producto',
      'unidad',
      'satID',
      'descripcion',
      'cantidad',
      'valor',
      'aplicaIVA',
      'importeIVA',
      'total',
      'cuentaPredial'
    ];
    public facturaDetalle: FacturaDetalle =  new FacturaDetalle();
    public unidadControl = new FormControl(null, [Validators.required]);
    public productoControl = new FormControl(null);
    
    public productoSATControl = new FormControl(null, [Validators.required]);
    public descripcionControl = new FormControl(null, [Validators.required, Validators.maxLength(250)]);
    public cantidadControl = new FormControl(null, [Validators.required, Validators.min(0), Validators.max(this.facturaDetalle.totalFaltante)]);
    public valorControl = new FormControl(null, [Validators.required, Validators.min(0)]);
    // public importeControl = new FormControl(null, [Validators.required, Validators.min(0), Validators.max(this.facturaDetalle.AMOUNT + this.facturaDetalle.totalFaltante)]);
    public importeIVAControl = new FormControl(null);
    public totalControl = new FormControl(null, [Validators.required, Validators.min(0)]);
    public aplicaIVAControl = new FormControl(true, [Validators.required]);
    public cuentaPredialControl = new FormControl(null);
    
    public commentsControl = new FormControl(null);
    public idCliente = null;
    private formularioValido = true;
    //public TipoFactura = false;

    private IVA_FIJO: number = .16;

    public impuestosRetenidosTotal = 0;

    public containsTaxGeneral = true;
    private loacs;

    // Sustitución (CFDI Relacionados, TipoRelacion 04)
    public sustituye = false;
    public listaTipoRelacion: any[] = [];
    public relationTypeSat04Id: number = null;
    public listaDocumentoRelacionar: any[] = [];
    public idsDocumentosRelacionados: number[] = [];

   
    tiposFacturas = [{idTF: 'I', nombre: 'Ingreso'},
                     {idTF: 'IC', nombre: 'Ingreso con carta porte'},
                     {idTF: 'T', nombre: 'Traslado'}]
    validarCuentaPredial = true;

    prodTerm = '';
    prodPage = 0;
    prodPageSize = 10;
    prodLoading = false;
    prodHasMore = true;
    private prodScrollSub?: Subscription;

    constructor(private formBuilder: FormBuilder, private _generalService: generalService, public dialog: MatDialog, public dataService: DataService, private route: ActivatedRoute) {
        this.dataService.guardado = false;
       // this.id =  +(this.route.snapshot.paramMap.get('id'));
    }

    onProdOpenedChange(opened: boolean) {
        if (!opened) {
            if (this.prodScrollSub) this.prodScrollSub.unsubscribe();
            return;
        }

        setTimeout(() => {
            const panel = document.querySelector('.mat-select-panel') as HTMLElement;
            if (!panel) return;

            if (this.prodScrollSub) this.prodScrollSub.unsubscribe();

            this.prodScrollSub = fromEvent(panel, 'scroll')
                .debounceTime(120)
                .subscribe(() => {
                    const nearBottom =
                        panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 20;

                    if (nearBottom) this.fetchMoreProd();
                });
        });
    }


    async ngOnInit() {
        this.route.params.subscribe(async (routeParams) => {
        this.loacs = sessionStorage.getItem("acslo");
        this.importeIVAControl.disable();
        this.buildForm();
       
        this.consultarCFDI();
        this.consultarFormaPago();
        this.consultarMetodoPago();
        this.consultarRegimenFiscales();
        this.consultarSucursales();
        this.consultSATcode();
        this.consultarUnidades();
        this.consultarCargo();
        this.consultarDataCompany();
        this.consultarTipoRelacion();
        this.consultarDocumentosRelacionar();
        await this.consultIVA();
        });
    }

    getProductoLabel(element: any): string {
  // 1) si el row ya trae SKU, úsalo
  const sku = element.SKU || element.sku;

  // 2) si no trae SKU, búscalo en tu catálogo listaProducto por ITEM_ID
  const prod = this.listaProducto?.find(p => p.ITEM_ID === element.ITEM_ID);

  const finalSku = sku || prod?.SKU;
  const finalName = element.NAME || prod?.NAME || '';

  return finalSku ? `${finalSku} - ${finalName}` : finalName;
}

    getVentasDetalle() {
        this._generalService.metodoCallParams(this.idDocuments, `factura/consultDocumentsByBill/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                console.log(res);
                this.ventaDetalleListado = res;
                if (this.id !== null) {  // Esta En modo Edicion
                    this.ventaDetalleListado.forEach((element) => {
                        const encontrado = this.listaFacturaDetalle.findIndex((obj) => obj.BILL_DETAIL_ID === element.BILL_DETAIL_ID);
                        if (encontrado !== -1) {
                            this.listaFacturaDetalle[encontrado].isChecked = true;
                            // Si tiene iva factor checkear Tiene Iva
                            if (this.listaFacturaDetalle[encontrado].IVA_FACTOR !== null && this.listaFacturaDetalle[encontrado].IVA_FACTOR !== undefined) {
                                this.listaFacturaDetalle[encontrado].checkedIva = true;
                            } else {
                                this.listaFacturaDetalle[encontrado].checkedIva = false;
                            }
                            // Proceso para descontar la cantidades y el monto
                           /* if (element.TOTAL !== this.listaFacturaDetalle[encontrado].AMOUNT) {
                                const totalFaltante = element.TOTAL - this.listaFacturaDetalle[encontrado].AMOUNT; // 20 - 10 = 10
                                this.listaFacturaDetalle[encontrado].totalFaltante = totalFaltante;
                            }*/
                        } else {
                            const id = this.listaFacturaDetalleAAgregar.length;
                            const unidad = this.listaUnidad.find((p) => p.BILL_UNIT_MEASURE_ID === element.BILL_UNIT_MEASURE_ID);

                            if(!this.containsTaxGeneral){
                                this.listaFacturaDetalle.push({
                                    BILL_DETAIL_ID: null,
                                    BILL_ID: null,
                                    ITEM_SAT_ID: element.ITEM_SAT_ID,
                                    ITEM_ID: element.ITEM_ID,
                                    UNIT_MEASURE_ID: element.BILL_UNIT_MEASURE_ID,
                                    AMOUNT: element.TOTAL, // Sin iba 16% // Sin iba 16%
                                    QUANTITY: element.QUANTITY,
                                    DESCRIPTION:  element.NAME,
                                    IVA_FACTOR: this.IVA_FIJO,  // IVA 16%
                                    IVA_AMOUNT: element.TOTAL * .16 ,  
                                    DOCUMENT_DETAIL_ID: element.DOCUMENT_DETAIL_ID,
                                    isChecked: true,
                                    checkedIva: true,
                                    total: (element.TOTAL + (element.TOTAL * .16 )).toFixed(6),
                                    totalFaltante: 0,
                                    price:  element.TOTAL / element.QUANTITY,
                                    index: id,
                                    NAME: element.NAME, // Producto
                                    NAME_SAT: element.NAME_SAT, // sat
                                    unidad: (unidad !== null && unidad !== undefined) ? unidad.NAME : '',
                                    DOCUMENT_ID: element.DOCUMENT_ID,
                                    AMOUNT_ORIGINAL: element.TOTAL,
                                    PREDIAL_ID:element.PREDIAL_ID,
                                    NAME_PREDIAL:element.NAME_PREDIAL,
                                    impuestoRetenido:element.impuestoRetenido,
                                    TYPE:element.TYPE,
                                });
                                this.listaFacturaDetalleAAgregar.push({
                                    BILL_DETAIL_ID: null,
                                    BILL_ID: null,
                                    ITEM_SAT_ID: element.ITEM_SAT_ID,
                                    ITEM_ID: element.ITEM_ID,
                                    UNIT_MEASURE_ID: element.element.BILL_UNIT_MEASURE_ID,
                                    AMOUNT: element.TOTAL , // Sin iba 16%
                                    QUANTITY: element.QUANTITY,
                                    DESCRIPTION: element.NAME,
                                    IVA_FACTOR: this.IVA_FIJO,  // IVA 16%
                                    IVA_AMOUNT: element.TOTAL * .16,  // 20 PESOS 16 %
                                    DOCUMENT_DETAIL_ID: element.DOCUMENT_DETAIL_ID,
                                    isChecked: true,
                                    checkedIva: true,
                                    total: (element.TOTAL + (element.TOTAL * .16 )).toFixed(6),
                                    totalFaltante: 0,
                                    price:  element.TOTAL / element.QUANTITY,
                                    index: id,
                                    NAME: element.NAME, // Producto
                                    NAME_SAT: element.NAME_SAT, // sat
                                    unidad: (unidad !== null && unidad !== undefined) ? unidad.NAME : '',
                                    DOCUMENT_ID: element.DOCUMENT_ID,
                                    AMOUNT_ORIGINAL: element.TOTAL,
                                    PREDIAL_ID:element.PREDIAL_ID,
                                    NAME_PREDIAL:element.NAME_PREDIAL,
                                    impuestoRetenido:element.impuestoRetenido,
                                    TYPE:element.TYPE,
                                });
                            }
                            else
                            {
                                this.listaFacturaDetalle.push({
                                    BILL_DETAIL_ID: null,
                                    BILL_ID: null,
                                    ITEM_SAT_ID: element.ITEM_SAT_ID,
                                    ITEM_ID: element.ITEM_ID,
                                    UNIT_MEASURE_ID: element.BILL_UNIT_MEASURE_ID,
                                    AMOUNT: element.TOTAL, // Sin iba 16% // Sin iba 16%
                                    QUANTITY: element.QUANTITY,
                                    DESCRIPTION:  element.NAME,
                                    IVA_FACTOR: this.IVA_FIJO,  // IVA 16%
                                    IVA_AMOUNT: (element.TOTAL * 16) / 116,  // 20 PESOS 16 %
                                    DOCUMENT_DETAIL_ID: element.DOCUMENT_DETAIL_ID,
                                    isChecked: true,
                                    checkedIva: true,
                                    total: element.TOTAL, // total con IVA
                                    totalFaltante: 0,
                                    price: (element.TOTAL - ((element.TOTAL * 16) / 116)) / element.QUANTITY,
                                    index: id,
                                    NAME: element.NAME, // Producto
                                    NAME_SAT: element.NAME_SAT, // sat
                                    unidad: (unidad !== null && unidad !== undefined) ? unidad.NAME : '',
                                    DOCUMENT_ID: element.DOCUMENT_ID,
                                    AMOUNT_ORIGINAL: element.TOTAL,
                                    PREDIAL_ID:element.PREDIAL_ID,
                                    NAME_PREDIAL:element.NAME_PREDIAL,
                                    impuestoRetenido:element.impuestoRetenido,
                                    TYPE:element.TYPE,
                                });
                                this.listaFacturaDetalleAAgregar.push({
                                    BILL_DETAIL_ID: null,
                                    BILL_ID: null,
                                    ITEM_SAT_ID: element.ITEM_SAT_ID,
                                    ITEM_ID: element.ITEM_ID,
                                    UNIT_MEASURE_ID: element.element.BILL_UNIT_MEASURE_ID,
                                    AMOUNT: element.TOTAL , // Sin iba 16%
                                    QUANTITY: element.QUANTITY,
                                    DESCRIPTION: element.NAME,
                                    IVA_FACTOR: this.IVA_FIJO,  // IVA 16%
                                    IVA_AMOUNT: (element.TOTAL * 16) / 116,  // 20 PESOS 16 %
                                    DOCUMENT_DETAIL_ID: element.DOCUMENT_DETAIL_ID,
                                    isChecked: true,
                                    checkedIva: true,
                                    total: element.TOTAL,
                                    totalFaltante: 0,
                                    price:  (element.TOTAL - ((element.TOTAL * 16) / 116)) / element.QUANTITY,
                                    index: id,
                                    NAME: element.NAME, // Producto
                                    NAME_SAT: element.NAME_SAT, // sat
                                    unidad: (unidad !== null && unidad !== undefined) ? unidad.NAME : '',
                                    DOCUMENT_ID: element.DOCUMENT_ID,
                                    AMOUNT_ORIGINAL: element.TOTAL,
                                    PREDIAL_ID:element.PREDIAL_ID,
                                    NAME_PREDIAL:element.NAME_PREDIAL,
                                    impuestoRetenido:element.impuestoRetenido,
                                    TYPE:element.TYPE,
                                });
                            }

                            
                            this.calcularValorUnitario(element.TOTAL, this.listaFacturaDetalle[this.listaFacturaDetalle.length - 1]);
                            
                        }
                    });

                
                } else { // No esta en modo edicion
                    this.listaFacturaDetalle = [];
                    this.listaFacturaDetalleAAgregar = [];
                    let index = 0;

                    this.ventaDetalleListado.forEach((element) => {

                        const unidad = this.listaUnidad.find((p) => p.BILL_UNIT_MEASURE_ID === element.BILL_UNIT_MEASURE_ID);
                        index++;
                        if(!this.containsTaxGeneral){
                            this.listaFacturaDetalle.push({
                                BILL_DETAIL_ID: null,
                                BILL_ID: null,
                                ITEM_SAT_ID: element.ITEM_SAT_ID,
                                ITEM_ID: element.ITEM_ID,
                                UNIT_MEASURE_ID: element.BILL_UNIT_MEASURE_ID,
                                AMOUNT: element.TOTAL, // Sin iba 16% ??
                                QUANTITY: element.QUANTITY,
                                DESCRIPTION: element.NAME,
                                IVA_FACTOR: this.IVA_FIJO,  // IVA 16%
                                IVA_AMOUNT: element.TOTAL * .16 ,  
                                DOCUMENT_DETAIL_ID: element.DOCUMENT_DETAIL_ID,
                                isChecked: true,
                                checkedIva: true,
                                total: (element.TOTAL + (element.TOTAL * .16 )).toFixed(6),
                                totalFaltante: element.totalFaltante,
                                price:  element.TOTAL / element.QUANTITY,
                                index,
                                NAME: element.NAME, // Producto
                                NAME_SAT: element.NAME_SAT, // sat
                                unidad: (unidad !== null && unidad !== undefined) ? unidad.NAME : '',
                                DOCUMENT_ID: element.DOCUMENT_ID,
                                AMOUNT_ORIGINAL: element.TOTAL,
                                PREDIAL_ID:element.PREDIAL_ID,
                                NAME_PREDIAL:element.NAME_PREDIAL,
                                impuestoRetenido:element.impuestoRetenido,
                                TYPE:element.TYPE,
                            });
                            this.listaFacturaDetalleAAgregar.push({
                                BILL_DETAIL_ID: null,
                                BILL_ID: null,
                                ITEM_SAT_ID: element.ITEM_SAT_ID,
                                ITEM_ID: element.ITEM_ID,
                                UNIT_MEASURE_ID: element.BILL_UNIT_MEASURE_ID,
                                AMOUNT: element.TOTAL , // Sin iba 16% ??
                                QUANTITY: element.QUANTITY,
                                DESCRIPTION: element.NAME,
                                IVA_FACTOR: this.IVA_FIJO,  // IVA 16%
                                IVA_AMOUNT: element.TOTAL * .16,  // 20 PESOS 16 %
                                DOCUMENT_DETAIL_ID: element.DOCUMENT_DETAIL_ID,
                                isChecked: true,
                                checkedIva: true,
                                total: (element.TOTAL + (element.TOTAL * .16 )).toFixed(6),
                                totalFaltante: element.totalFaltante,
                                price:  element.TOTAL / element.QUANTITY,
                                index,
                                NAME: element.NAME, // Producto
                                NAME_SAT: element.NAME_SAT, // sat
                                unidad: (unidad !== null && unidad !== undefined) ? unidad.NAME : '',
                                DOCUMENT_ID: element.DOCUMENT_ID,
                                AMOUNT_ORIGINAL: element.TOTAL,
                                PREDIAL_ID:element.PREDIAL_ID,
                                NAME_PREDIAL:element.NAME_PREDIAL,
                                impuestoRetenido:element.impuestoRetenido,
                                TYPE:element.TYPE,
                            });
                        }
                        else
                        {
                            this.listaFacturaDetalle.push({
                                BILL_DETAIL_ID: null,
                                BILL_ID: null,
                                ITEM_SAT_ID: element.ITEM_SAT_ID,
                                ITEM_ID: element.ITEM_ID,
                                UNIT_MEASURE_ID: element.BILL_UNIT_MEASURE_ID,
                                AMOUNT: element.TOTAL -((element.TOTAL * 16) / 116),
                                QUANTITY: element.QUANTITY,
                                DESCRIPTION: element.NAME,
                                IVA_FACTOR: this.IVA_FIJO,  // IVA 16%
                                IVA_AMOUNT: (element.TOTAL * 16) / 116,  // 20 PESOS 16 %
                                DOCUMENT_DETAIL_ID: element.DOCUMENT_DETAIL_ID,
                                isChecked: true,
                                checkedIva: true,
                                total: element.TOTAL,
                                totalFaltante: element.totalFaltante,
                                price: (element.TOTAL - ((element.TOTAL * 16) / 116)) / element.QUANTITY,
                                index,
                                NAME: element.NAME, // Producto
                                NAME_SAT: element.NAME_SAT, // sat
                                unidad: (unidad !== null && unidad !== undefined) ? unidad.NAME : '',
                                DOCUMENT_ID: element.DOCUMENT_ID,
                                AMOUNT_ORIGINAL: element.TOTAL,
                                PREDIAL_ID:element.PREDIAL_ID,
                                NAME_PREDIAL:element.NAME_PREDIAL,
                                impuestoRetenido:element.impuestoRetenido,
                                TYPE:element.TYPE,
                            });
                            this.listaFacturaDetalleAAgregar.push({
                                BILL_DETAIL_ID: null,
                                BILL_ID: null,
                                ITEM_SAT_ID: element.ITEM_SAT_ID,
                                ITEM_ID: element.ITEM_ID,
                                UNIT_MEASURE_ID: element.BILL_UNIT_MEASURE_ID,
                                AMOUNT: element.TOTAL -((element.TOTAL * 16) / 116), // Sin iba 16%
                                QUANTITY: element.QUANTITY,
                                DESCRIPTION: element.NAME,
                                IVA_FACTOR: this.IVA_FIJO,  // IVA 16%
                                IVA_AMOUNT: (element.TOTAL * 16) / 116,  // 20 PESOS 16 %
                                DOCUMENT_DETAIL_ID: element.DOCUMENT_DETAIL_ID,
                                isChecked: true,
                                checkedIva: true,
                                total: element.TOTAL,
                                totalFaltante: element.totalFaltante,
                                price:  (element.TOTAL - ((element.TOTAL * 16) / 116)) / element.QUANTITY,
                                index,
                                NAME: element.NAME, // Producto
                                NAME_SAT: element.NAME_SAT, // sat
                                unidad: (unidad !== null && unidad !== undefined) ? unidad.NAME : '',
                                DOCUMENT_ID: element.DOCUMENT_ID,
                                AMOUNT_ORIGINAL: element.TOTAL,
                                PREDIAL_ID:element.PREDIAL_ID,
                                NAME_PREDIAL:element.NAME_PREDIAL,
                                impuestoRetenido:element.impuestoRetenido,
                                TYPE:element.TYPE,
                            });
                        }
                        this.calcularValorUnitario(element.TOTAL, this.listaFacturaDetalle[this.listaFacturaDetalle.length - 1]);
                    });
                }
                

                setTimeout( () => {
                    this.dataSource.data = this.listaFacturaDetalle;
                    this.calcularTotal();
                });
            },
            (error) => {
            console.log( error as any);
            }
        );
    }

    getFactura(id: any) {
        this.factura.BILL_ID = this.dataService.id;
        this._generalService.metodoCallParams(this.factura, `factura/getBill/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res.length > 0) {
                    this.factura = res[0];
                    // this.facturaAgregar.controls['sucursal'].setValue(this.factura.ORGANIZATION_ID);
                    this.facturaAgregar.controls['regimenFiscal'].setValue(this.factura.TAX_REGIME_ID);
                    this.facturaAgregar.controls['nombre'].setValue(this.factura.CUSTOMER_NAME);
                    this.facturaAgregar.controls['rfc'].setValue(this.factura.CUSTOMER_RFC);
                    this.facturaAgregar.controls['formaPago'].setValue(this.factura.RECEIVER_PAYMENT_FORM_ID);
                    this.facturaAgregar.controls['metodoPago'].setValue(this.factura.RECEIVER_PAYMENT_METHOD_ID);
                    this.facturaAgregar.controls['cfdi'].setValue(this.factura.RECEIVER_CFDI_USE_ID);
                    this.facturaAgregar.controls['tipoFacturao'].setValue(this.factura.INVOICE_TYPE);
                    this.commentsControl.setValue(this.factura.COMMENTS);
                    if (this.factura.BILL_STATUS_ID !== 1) {
                        this.displayedColumns = [
                            'producto',
                            'unidad',
                            'satID',
                            'descripcion',
                            'cantidad',
                            'valor',
                            'aplicaIVA',
                            'importeIVA',
                            'total',
                            'cuentaPredial'
                        ];
                    } else {
                        this.displayedColumns = [
                            'activo',
                            'acciones',
                            'producto',
                            'unidad',
                            'satID',
                            'descripcion',
                            'cantidad',
                            'valor',
                            'aplicaIVA',
                            'importeIVA',
                            'total',
                            'cuentaPredial'
                        ];
                    }

                }
            },
            (error) => {
            console.log( error as any);
            }
        );
    }

    getFacturaDetalle(id: any) {
        this.listaFacturaDetalle = [];
        this.listaFacturaDetalleAAgregar = [];
        this.factura.BILL_ID = this.dataService.id;
        this._generalService.metodoCallParams(this.factura, `factura/getBillDetail/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                console.log(res);
                this.listaFacturaDetalle = res;
                this.listaFacturaDetalleAAgregar = [];
                for (let i = 0; i < this.listaFacturaDetalle.length; i++) {
                    this.listaFacturaDetalle[i].index = i;
                    this.listaFacturaDetalle[i].AMOUNT_ORIGINAL = this.listaFacturaDetalle[i].AMOUNT;
                    this.listaFacturaDetalle[i].isChecked = true;
                    this.listaFacturaDetalle[i].price = Math.round(((this.listaFacturaDetalle[i].AMOUNT / this.listaFacturaDetalle[i].QUANTITY) + Number.EPSILON) * 100) / 100;
                    if (this.listaFacturaDetalle[i].IVA_FACTOR !== null && this.listaFacturaDetalle[i].IVA_FACTOR !== undefined) {
                        this.listaFacturaDetalle[i].checkedIva = true;
                    } else {
                        this.listaFacturaDetalle[i].checkedIva = false;
                    }
                    this.listaFacturaDetalleAAgregar.push(this.listaFacturaDetalle[i]);
                }
                if (this.dataService.factura.idDocuments !== null &&  this.dataService.factura.idDocuments !== undefined) {
                    this.idDocuments = this.dataService.factura.idDocuments;
                    this.facturaTipo = this.dataService.factura.tipoFactura; // 1 Ventas y 2 Libre
                    if (this.facturaTipo === 1 && this.idDocuments !== null && this.idDocuments !== undefined) {
                        this.getVentasDetalle();
                    } else {
                        setTimeout( () => {
                            this.dataSource.data = this.listaFacturaDetalle;
                            this.calcularTotal();
                          });
                    }
                } else {
                    setTimeout( () => {
                        this.dataSource.data = this.listaFacturaDetalle;
                        this.calcularTotal();
                        this.calcularImpuestosRetenidos();
                      });
                }
                this._generalService.metodoCallParams(this.factura, `factura/getBillDetailImpuestoRetenido/`).subscribe(
                    (result) => {
                        const res = JSON.parse(result);
                        console.warn(res);
                        this.listaFacturaDetalleImpuestosRetenidos = res;
                        // this.listaFacturaDetalleImpuestosRetenidos.forEach(elemento => {
                        //     this.impuestosRetenidosTotal += elemento.AMOUNT;
                        // });
                        // Iterar sobre los elementos de this.listaFacturaDetalleImpuestosRetenidos
                        for (const impuestoRetenido of this.listaFacturaDetalleImpuestosRetenidos) {
                            const BILL_DETAIL_ID = impuestoRetenido.BILL_DETAIL_ID;

                            // Buscar si el BILL_DETAIL_ID existe en listaFacturaDetalleAAgregar
                            const facturaDetalleAgregar = this.listaFacturaDetalleAAgregar.find((facturaDetalle) => facturaDetalle.BILL_DETAIL_ID === BILL_DETAIL_ID);

                            // Si encontramos un elemento en listaFacturaDetalleAAgregar con el mismo BILL_DETAIL_ID
                            if (facturaDetalleAgregar) {
                                // Asegurarse de que facturaDetalleAgregar.impuestoRetenido es un objeto
                                if (!facturaDetalleAgregar.impuestoRetenido) {
                                    facturaDetalleAgregar.impuestoRetenido = {}; // Inicializamos impuestoRetenido si aún no está definido como un objeto
                                }

                                // Asignar impuestoRetenido a la propiedad impuestosRetenidosData
                                if (!facturaDetalleAgregar.impuestoRetenido.impuestosRetenidosData) {
                                    facturaDetalleAgregar.impuestoRetenido.impuestosRetenidosData = []; // Inicializamos impuestosRetenidosData si aún no está definido como un array
                                }
                                facturaDetalleAgregar.impuestoRetenido.impuestosRetenidosData.push(impuestoRetenido);
                            }
                        }
                        this.calcularImpuestosRetenidos();
                        
        
                    },
                    (error) => {
                        //
                    }
                );
            },
            (error) => {
            console.log( error as any);
            }
        );
    }

    buildForm() {
        if(this.dataService.factura.idCliente == null || this.dataService.factura.idCliente == undefined){
            this.facturaAgregar = this.formBuilder.group({
                // sucursal: this.formBuilder.control(null, [Validators.required] ),
                 regimenFiscal: this.formBuilder.control(null, [Validators.required] ),
                 nombre: this.formBuilder.control(null, [Validators.required, Validators.maxLength(250)]),
                 rfc: this.formBuilder.control(null, [Validators.required, Validators.maxLength(250)]),
                 formaPago: this.formBuilder.control({ value: null, disabled: true }),
                 
                 metodoPago: this.formBuilder.control({ value: null, disabled: true }),
                 cfdi: this.formBuilder.control({ value: null, disabled: true }),
                 tipoFacturao: this.formBuilder.control(null, [Validators.required])
             });
        
        }else{
             this.facturaAgregar = this.formBuilder.group({
           // sucursal: this.formBuilder.control(null, [Validators.required] ),
            regimenFiscal: this.formBuilder.control(null, [Validators.required] ),
            nombre: this.formBuilder.control(null, [Validators.required, Validators.maxLength(250)]),
            rfc: this.formBuilder.control(null, [Validators.required, Validators.maxLength(250)]),
            formaPago: this.formBuilder.control(null, [Validators.required] ),
            metodoPago: this.formBuilder.control(null, [Validators.required] ),
            cfdi: this.formBuilder.control(null, [Validators.required]),
            tipoFacturao: this.formBuilder.control(null, [Validators.required])
        });
        }
       

        /* this.facturaAgregar2 = this.formBuilder.group({
            sucursal: this.formBuilder.control(null, [Validators.required] ),
            regimenFiscal: this.formBuilder.control(null, [Validators.required] ),
            nombre: this.formBuilder.control(null, [Validators.required, Validators.maxLength(250)]),
            rfc: this.formBuilder.control(null,[Validators.required, Validators.maxLength(250)]),
            formaPago: this.formBuilder.control(null, [Validators.required] ),
            metodoPago: this.formBuilder.control(null, [Validators.required] ),
            serie: this.formBuilder.control(null,[Validators.required]),
            cfdi: this.formBuilder.control(null, [Validators.required])
        });*/
        /*this.facturaAgregar.get('personalNombre').disable();
        this.facturaAgregar.get('personalPaterno').disable();
        this.facturaAgregar.get('personalMaterno').disable();*/

    }

    cerrarModal() {
        this.dataService.dialogRef.close();
    }

    /* Sustitución (CFDI Relacionados, TipoRelacion 04) */
    consultarTipoRelacion() {
        this._generalService.metodoCall(`NotaCredito/consultarTipoRelacion/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    this.listaTipoRelacion = res;
                    const tipo04 = this.listaTipoRelacion.find((ele) => ele.RELATION_TYPE_SAT_KEY === '04');
                    this.relationTypeSat04Id = (tipo04 !== undefined && tipo04 !== null) ? tipo04.RELATION_TYPE_SAT_ID : null;
                } else {
                    this.listaTipoRelacion = [];
                }
            },
            (error) => {
                this.listaTipoRelacion = [];
            }
        );
    }

    consultarDocumentosRelacionar() {
        const idCliente = this.dataService.factura.idCliente;
        if (idCliente === null || idCliente === undefined) {
            this.listaDocumentoRelacionar = [];
            return;
        }
        this._generalService.metodoCall(`RecepcionPago/getDocumentos?CUSTOMER_ID=` + idCliente).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    this.listaDocumentoRelacionar = res;
                } else {
                    this.listaDocumentoRelacionar = [];
                }
            },
            (error) => {
                this.listaDocumentoRelacionar = [];
            }
        );
    }

    getDocumentosRelacionados(id: any) {
        const factura: any = { BILL_ID: id };
        this._generalService.metodoCallParams(factura, `factura/getBillDocumentosRelacionados/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    this.idsDocumentosRelacionados = res.map((d) => d.RELATED_BILL_ID);
                    this.sustituye = true;
                } else {
                    this.idsDocumentosRelacionados = [];
                    this.sustituye = false;
                }
            },
            (error) => {
                this.idsDocumentosRelacionados = [];
                this.sustituye = false;
            }
        );
    }

    onChangeSustituye() {
        if (!this.sustituye) {
            this.idsDocumentosRelacionados = [];
        }
    }

    timbrar() {
        const metodo = 'factura/timbrarFactura';
        this.factura.BILL_ID = this.dataService.id;
        this._generalService.metodoCallParams(this.factura, metodo).subscribe(
                (result) => {
                this.dataService.guardado = true;
                this._generalService.toastCall('La factura se timbró exitosamente!');
                // this.cerrarModal();
                },
                (error) => {
                const errorMsj =  error as any;
                console.log(errorMsj);
                }
            );
    }
    listaFacturaDetalleImpuestosRetenidos: any[] = [];
   

    /*
        listaSucursal: Organizacion[] = [];
        listaRegimenFiscal: FacturaRegimenFiscal[] = [];
        listaFormaPago: FacturaFormaPago[] = [];
        listaMetodoPago: FacturaMetodoPago[] = [];
        listaCFDI: FacturaUsoCFDI[] = [];

        listaProducto: Item[] = [];
        listaUnidad: FacturaUnidadMedida[] = [];
    */

    consultarSucursales() {
        this._generalService.metodoCall(`compania/consultarSucursales/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    this.listaSucursal = res;
                } else {
                    this.listaSucursal = [];
                }
                const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
                const idOrganizacion = usuarioSession.ORGANIZATION_ID;
                const idCompania = this.listaSucursal.find((row) => row.ORGANIZATION_ID === +idOrganizacion).COMPANY_ID;
                // this.consultarCompania();
                this.consultarProducto(idCompania);
            },
            (error) => {
                this.listaSucursal = [];
                console.log( error as any);
            }
        );
    }

    /*changeSucursal() {
        if (this.facturaAgregar.controls['sucursal'].value !== null && this.facturaAgregar.controls['sucursal'].value !== undefined) {
            const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
            const idOrganizacion = usuarioSession.ORGANIZATION_ID;
            const idCompania = this.listaSucursal.find((row) => row.ORGANIZATION_ID === +idOrganizacion).COMPANY_ID;
            this.consultarProducto(idCompania);
        } else {
            this.listaProducto = [];
        }
    }*/

    consultarCompania() {
        const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
        const idOrganizacion = usuarioSession.ORGANIZATION_ID;
        const idCompania = this.listaSucursal.find((row) => row.ORGANIZATION_ID === +idOrganizacion).COMPANY_ID;
        const params = {
            idCompania
        };
        this._generalService.metodoCallParams(params, `factura/consultEmisor/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    if (res[0].BILL_TAX_REGIME_ID !== null && res[0].BILL_TAX_REGIME_ID !== undefined && this.dataService.tipo !== 'editar') {
                        this.facturaAgregar.controls['regimenFiscal'].setValue(res[0].BILL_TAX_REGIME_ID);
                    }
                }
            },
            (error) => {
                console.log( error as any);
            }
        );
    }

    consultarRegimenFiscales() {
        this._generalService.metodoCall(`factura/getRegimenFiscal/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    this.listaRegimenFiscal = res;
                } else {
                    this.listaRegimenFiscal = [];
                }
            },
            (error) => {
                this.listaRegimenFiscal = [];
                console.log( error as any);
            }
        );
    }

    consultarFormaPago() {
        this._generalService.metodoCall(`factura/getFormaPago/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    this.listaFormaPago = res;
                } else {
                    this.listaFormaPago = [];
                }
            },
            (error) => {
                this.listaFormaPago = [];
                console.log( error as any);
            }
        );
    }

    consultarMetodoPago() {
        this._generalService.metodoCall(`factura/getMetodoPago/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    this.listaMetodoPago = res;
                } else {
                    this.listaMetodoPago = [];
                }
            },
            (error) => {
                this.listaMetodoPago = [];
                console.log( error as any);
            }
        );
    }

    consultarCFDI() {
        this._generalService.metodoCall(`factura/getCFDI/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    this.listaCFDI = res;
                } else {
                    this.listaCFDI = [];
                }
            },
            (error) => {
                this.listaCFDI = [];
                console.log( error as any);
            }
        );
    }

    consultarProducto(idCompania: number) {
        /*const factura: any = {};
        factura.loacs = sessionStorage.getItem('acslo');
        this._generalService.metodoCallParams(factura, `factura/consultItems/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    this.listaProducto = res;
                } else {
                    this.listaProducto = [];
                }
            },
            (error) => {
                this.listaProducto = [];
                console.log( error as any);
            }
        ); */
       /* const params = {
            idDocuments: idCompania
        };*/
        this._generalService.metodoCallParams(idCompania, `factura/consultProductos/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    this.listaProducto = res;
                    this.viewDataProd = this.listaProducto.slice(0, this.itemsShowProd);
                    this.viewDataProdEdit = this.viewDataProd;
                    this.listaProductoEdit = JSON.parse(result);
                } else {
                    this.listaProducto = [];
                }
            },
            (error) => {
                this.listaProducto = [];
                console.log( error as any);
            }
        );
    }

    consultSATcode() {
        this.matOptions = new Object();
        this.matOptions.SATcodes = [];

        this._generalService.metodoCall(`itemCodeSAT/consultItemSATcodes/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    this.listaSATCode = res;
                    this.viewDataSat = this.listaSATCode.slice(0, this.itemsShowSat);
                    this.viewDataSatEdit = this.viewDataSat;
                    this.listaSATCodeEdit = JSON.parse(result);
                } else {
                    this.listaSATCode = [];
                }
            },
            (error) => {
                this.listaSATCode = [];
                console.log( error as any);
            }
        );
    }

    consultarCargo() {
        this._generalService.metodoCall(`factura/getCargo/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    this.listaCargo = res;
                } else {
                    this.listaCargo = [];
                }
            },
            (error) => {
                this.listaCargo = [];
                console.log( error as any);
            }
        );
    }

    consultarUnidades() {
        this._generalService.metodoCall(`factura/getUnidades/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    this.listaUnidad = res;
                } else {
                    this.listaUnidad = [];
                }
            },
            (error) => {
                this.listaUnidad = [];
                console.log( error as any);
            }
        );
    }

    consultIVA() {
        this._generalService.metodoCallParams(this.loacs, 'itemLookUp/consultIVA')
            .subscribe(itemIVA => {
              itemIVA = JSON.parse(itemIVA);
              if(itemIVA.length > 0)
              {
                this.containsTaxGeneral = false;
              }
              else
              {
                this.containsTaxGeneral = true;
              }
              
              if (this.dataService.tipo === 'editar') {
                this.titulo = 'Editar';
                this.id = this.dataService.id;
                this.facturaTipo = this.dataService.factura.tipoFactura; // 1 Ventas y 2 Libre
                this.idCliente = this.dataService.factura.idCliente;
                this.getFactura(this.dataService.id);
                this.getFacturaDetalle(this.dataService.id);
                this.getDocumentosRelacionados(this.dataService.id);
               // this.buscarFamiliar(this.id);
            } else {
                this.idDocuments = this.dataService.factura.idDocuments;
                this.facturaTipo = this.dataService.factura.tipoFactura; // 1 Ventas y 2 Libre
                this.idCliente = this.dataService.factura.idCliente;
                this.facturaAgregar.controls['nombre'].setValue(this.dataService.factura.CUSTOMER_NAME);
                //this.facturaAgregar.controls['cfdi'].setValue(3); // Gastos Generales
                this.facturaAgregar.controls['rfc'].setValue(this.dataService.factura.CUSTOMER_RFC);
                this.facturaAgregar.controls['regimenFiscal'].setValue(this.dataService.factura.BILL_TAX_REGIME_ID);
                this.facturaAgregar.controls['cfdi'].setValue(this.dataService.factura.BILL_CFDI_USE_ID);
                this.factura = new Factura();
                this.factura.CUSTOMER_RFC = this.dataService.factura.CUSTOMER_RFC;
                this.factura.CUSTOMER_NAME = this.dataService.factura.CUSTOMER_NAME;
                this.factura.BILL_STATUS_ID = 1;
                if (this.facturaTipo === 1 && this.idDocuments !== null && this.idDocuments !== undefined) {
                    this.getVentasDetalle();
                }
            }

            }, error => {
              // Custom error handler
            });
    }

    regresar() {
        this.siguiente = false;
        this.establecerValoresPorDefecto();
    }

    onNext() {
        if (this.validarForm()) {
            this.factura.TAX_REGIME_ID = this.facturaAgregar.controls['regimenFiscal'].value;
            this.factura.CUSTOMER_NAME = this.facturaAgregar.controls['nombre'].value;
            this.factura.CUSTOMER_RFC = this.facturaAgregar.controls['rfc'].value;
            this.factura.RECEIVER_PAYMENT_FORM_ID = this.facturaAgregar.controls['formaPago'].value;
            this.factura.RECEIVER_PAYMENT_METHOD_ID = this.facturaAgregar.controls['metodoPago'].value;
            this.factura.RECEIVER_CFDI_USE_ID = this.facturaAgregar.controls['cfdi'].value;

           
            this.factura.INVOICE_TYPE = this.facturaAgregar.controls['tipoFacturao'].value;

            this.siguiente = true;
        }
    }

    guardarFacturaDetalleHeader() {
        this.validarFormulario();
        if (this.formularioValido) {
        this.mapearDatosFormControlEnModelo();
        this.agregarFacturaDetalle();
        }
        
    }
    
    guardarFacturaDetalleRow() {
        this.validarFormulario();
        if (this.formularioValido) {
            this.mapearDatosFormControlEnModelo();
            this.editarFacturaDetalle();
        }
     
    }


    agregarFacturaDetalle() {
        let index = 0;
        if (this.listaFacturaDetalle.length === 0) {
             index = 0;
        } else {
             index = this.listaFacturaDetalle.length;
        }
        this.facturaDetalle.index = index;
        this.listaFacturaDetalleAAgregar[index] = this.facturaDetalle;
        this.listaFacturaDetalle.push(this.facturaDetalle);

        this.seEstaAgregando = false;
        this.seEstaEditando = false;
        setTimeout( () => {
          this.dataSource.data = this.listaFacturaDetalle;
          this.calcularTotal();
        });
        /*if (this.generarPolizaDolaresForm.value) {
          this.confirmarCambiarTipoCambio();
        } */
      }

      editarFacturaDetalle() {
        const index1 = this.listaFacturaDetalle.findIndex((element) => element.index === this.facturaDetalle.index);
        // const index2 = this.listaFacturaDetalleAAgregar.findIndex((element) => element.index === this.facturaDetalle.index);
        this.listaFacturaDetalleAAgregar[index1] = this.facturaDetalle;
        this.listaFacturaDetalle[index1] =  this.facturaDetalle;
        this.seEstaAgregando = false;
        this.seEstaEditando = false;
        setTimeout( () => {
          this.dataSource.data = this.listaFacturaDetalle;
          this.calcularTotal();
        });
      }

    setAccionAgregar() {
        this.establecerValoresPorDefecto();
        this.seEstaEditando = false;
        this.seEstaAgregando = true;
        /***************************INFINITE SELECT**********************************/    
         setTimeout(() => 
                    this.selectElem.onOpen.subscribe(() => this.registerPanelScrollEvent()),
                0);

         setTimeout(() => 
                    this.selectElemSat.onOpen.subscribe(() => this.registerPanelScrollEventSat()),
                0);
        /***************************INFINITE SELECT**********************************/
    }

    cancelarAccion() {
    this.establecerValoresPorDefecto();
    }

    validarFormulario() {
        this.formularioValido = false;
        const campoRequerido = 'Favor de llenar los campos requeridos';
        this.resaltarCamposConErrores();
        if (
            this.unidadControl.invalid ||
            this.productoControl.invalid ||
            this.productoSATControl.invalid ||
            this.descripcionControl.invalid ||
            this.cantidadControl.invalid ||
            this.valorControl.invalid ||
            this.importeIVAControl.invalid ||
            this.totalControl.invalid ||
            this.aplicaIVAControl.invalid ||
            this.cuentaPredialControl.invalid
        ) {
            this._generalService.toastCall(campoRequerido);
            return;
        }

        if (this.facturaDetalle.DOCUMENT_DETAIL_ID !== null &&  this.facturaDetalle.totalFaltante !== null && (this.cantidadControl.value > this.facturaDetalle.totalFaltante)) {
            this._generalService.toastCall('La cantidad sobrepaso al limite de la venta (Maximo ' + (this.facturaDetalle.totalFaltante) + ')');
            return;
        } 

        this.formularioValido = true;
    }

    resaltarCamposConErrores() {
        this.unidadControl.markAsTouched();
        this.productoControl.markAsTouched();
        this.productoSATControl.markAsTouched();
        this.descripcionControl.markAsTouched();
        this.cantidadControl.markAsTouched();
        this.valorControl.markAsTouched();
        //  this.importeControl.markAsTouched();
        this.cuentaPredialControl.markAsTouched();
     
        this.importeIVAControl.markAsTouched();
        this.totalControl.markAsTouched();
        this.aplicaIVAControl.markAsTouched();
    }

    mapearDatosFormControlEnModelo() {

        this.facturaDetalle.UNIT_MEASURE_ID = this.unidadControl.value;
        this.facturaDetalle.ITEM_ID = this.productoControl.value;
        const producto = this.listaProducto.find((p) => p.ITEM_ID === this.facturaDetalle.ITEM_ID);
        if (producto !== null && producto !== undefined) {
            this.facturaDetalle.ITEM_SAT_ID = producto.ITEM_SAT_ID;
            this.facturaDetalle.NAME_SAT = producto.NAME_SAT;
            this.facturaDetalle.NAME = producto.NAME;
            this.facturaDetalle.TYPE = producto.TYPE
        }
        this.facturaDetalle.ITEM_SAT_ID = this.productoSATControl.value;
        const productoSAT =  this.listaSATCode.find((p) => p.itemSATcodeId === this.productoSATControl.value);
        if (productoSAT !== null && productoSAT !== undefined) {
            this.facturaDetalle.NAME_SAT = productoSAT.SATcode  + ' - ' + productoSAT.DESCRIPTION;
            
        }
        this.facturaDetalle.DESCRIPTION = this.descripcionControl.value;
        
        this.facturaDetalle.QUANTITY = +this.cantidadControl.value;
        this.facturaDetalle.price = +this.valorControl.value;
         
        this.facturaDetalle.PREDIAL_ID = this.cuentaPredialControl.value;
        const cuentaPredial =  this.listaPredial.find((p) => p.PREDIAL_ID === this.cuentaPredialControl.value);
        if (cuentaPredial !== null && cuentaPredial !== undefined) {
            this.facturaDetalle.NAME_PREDIAL = cuentaPredial.NAME;
        }
        if (this.aplicaIVAControl.value !== false && this.aplicaIVAControl.value !== undefined) {
            this.facturaDetalle.IVA_FACTOR = this.IVA_FIJO;
            this.facturaDetalle.IVA_AMOUNT =  +this.importeIVAControl.value;
            this.facturaDetalle.checkedIva = true;
            this.facturaDetalle.AMOUNT = +this.totalControl.value - +this.importeIVAControl.value;
            this.facturaDetalle.AMOUNT = +this.facturaDetalle.AMOUNT.toFixed(6);
        } else {
            this.facturaDetalle.IVA_FACTOR = null;
            this.facturaDetalle.checkedIva = false;
            this.facturaDetalle.IVA_AMOUNT = 0.000;
            this.facturaDetalle.AMOUNT = +this.totalControl.value;
            this.facturaDetalle.AMOUNT = +this.facturaDetalle.AMOUNT.toFixed(6);
        }
        this.facturaDetalle.isChecked = true;
        const unidad = this.listaUnidad.find((p) => p.BILL_UNIT_MEASURE_ID === this.facturaDetalle.UNIT_MEASURE_ID);
        this.facturaDetalle.unidad = unidad.NAME;
        this.facturaDetalle.total = +this.totalControl.value;
        
        // this.facturaDetalle.index = this.listaFacturaDetalle.length++;
        // this.facturaDetalle.total = this.totalControl.value;
        // this.facturaDetalle.aplicaIVA = this.aplicaIVAControl.value;
    }

    establecerValoresPorDefecto() {
        this.seEstaAgregando = false;
        this.seEstaEditando = false;
        this.facturaDetalle = new FacturaDetalle();

        this.unidadControl.reset();
        this.productoControl.reset();
        this.productoSATControl.reset();
        this.descripcionControl.reset();
        this.cantidadControl.reset();
        this.valorControl.reset();
        // this.importeControl.reset();
        this.cuentaPredialControl.reset();
        
        this.importeIVAControl.reset();
        this.totalControl.reset(0);
        this.aplicaIVAControl.reset(true);
        this.itemsShowProd = 10;
        this.itemsShowSat = 10;
        //this.validarCuentaPredial = true;
    }

    establecerDetalle(facturaDetalle: FacturaDetalle) {
        // this.seEstaAgregando = false;
        // this.seEstaEditando = true;
        
        /***************************INFINITE SELECT**********************************/    
         setTimeout(() => 
                    this.selectElem.onOpen.subscribe(() => this.registerPanelScrollEvent()),
                0);

         setTimeout(() => 
                    this.selectElemSat.onOpen.subscribe(() => this.registerPanelScrollEventSat()),
                0);
        /***************************INFINITE SELECT**********************************/
        this.facturaDetalle = facturaDetalle;
        this.facturaDetalle.BILL_DETAIL_ID = facturaDetalle.BILL_DETAIL_ID;
        this.transaccionEnCurso = true;
        this.unidadControl.setValue(facturaDetalle.UNIT_MEASURE_ID);
        this.productoControl.setValue(facturaDetalle.ITEM_ID);
        const producto = this.listaProducto.find((p) => p.ITEM_ID === this.facturaDetalle.ITEM_ID);

        this.moverSeleccion();
        this.moverSeleccionSat();
       /* if (producto !== null && producto !== undefined) {
            this.facturaDetalle.ITEM_SAT_ID = producto.ITEM_SAT_ID;
            // this.facturaDetalle.NAME_SAT = producto.NAME_SAT;
        }
*/
     
        this.productoSATControl.setValue(this.facturaDetalle.ITEM_SAT_ID);
        const productoSAT = this.listaSATCode.find((p) => p.itemSATcodeId === this.productoSATControl.value);
        if (productoSAT !== null && productoSAT !== undefined) {
            this.facturaDetalle.NAME_SAT = productoSAT.SATcode  + ' - ' + productoSAT.DESCRIPTION;
        }

        this.descripcionControl.setValue(facturaDetalle.DESCRIPTION);
        this.cantidadControl.setValue(facturaDetalle.QUANTITY);
        this.valorControl.setValue(facturaDetalle.price);
       // this.importeControl.setValue(facturaDetalle.AMOUNT);
       this.cuentaPredialControl.setValue(facturaDetalle.PREDIAL_ID);
       
        this.importeIVAControl.setValue(facturaDetalle.IVA_AMOUNT);
        this.totalControl.setValue(facturaDetalle.total);
        if (facturaDetalle.IVA_AMOUNT !== null && facturaDetalle.IVA_AMOUNT !== undefined && facturaDetalle.IVA_AMOUNT > 0) {
            this.aplicaIVAControl.setValue(true);
        } else {
            this.aplicaIVAControl.setValue(false);
        }
      //  this.calcularTotalRow();

        //this.transaccionEnCurso = false;
        
        this.validarCuentaPredial;
        if(producto.TYPE == 'A'){
            this.validarCuentaPredial = false;
        }else{
            this.validarCuentaPredial = true;
        }

        
        setTimeout(() => {
            this.seEstaAgregando = false;
            this.seEstaEditando = true;
            this.transaccionEnCurso = false;
        }, 100);
        
    }

    moverSeleccion() {
        /***************************INFINITE SELECT**********************************/
        const index = this.listaProductoEdit.findIndex(x => x.ITEM_ID == this.facturaDetalle.ITEM_ID);
        var a = this.listaProductoEdit.splice(index,1);
        this.listaProductoEdit.unshift(a[0]);
        this.itemsShowProd = 10;
        this.viewDataProdEdit = this.listaProductoEdit.slice(0, 10);
        /***************************INFINITE SELECT**********************************/
    }

    moverSeleccionSat() {
        /***************************INFINITE SELECT**********************************/
        const index = this.listaSATCodeEdit.findIndex(x => x.itemSATcodeId == this.facturaDetalle.ITEM_SAT_ID);
        var a = this.listaSATCodeEdit.splice(index,1);
        this.listaSATCodeEdit.unshift(a[0]);
        this.itemsShowSat = 10;
        this.viewDataSatEdit = this.listaSATCodeEdit.slice(0, 10);
        /***************************INFINITE SELECT**********************************/
    }

    eliminarFacturaDetalle(facturaDetalle: FacturaDetalle) {

        const metodo = 'factura/deleteFacturaDetalle';
        this._generalService.metodoCallParams(facturaDetalle, metodo).subscribe(
            (result) => {
                this._generalService.toastCall('Se ha eliminado el renglon exitosamente!');
                this.getFacturaDetalle(this.dataService.id);
            },
            (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj);
            }
        );

    }

    eliminar(id) {
        const index1 = this.listaFacturaDetalle.findIndex((element) => element.index === id);
        // const index2 = this.listaFacturaDetalleAAgregar.findIndex((element) => element.index === id);
        this.listaFacturaDetalle.splice(index1, 1);
        this.listaFacturaDetalleAAgregar.splice(index1, 1);
        setTimeout( () => {
            this.dataSource.data = this.listaFacturaDetalle;
            this.calcularTotal();
        });
    }

    guardarFactura() {
        if (this.validarGuardar()) {
           this.btnGuardar = true;
            let metodo = 'factura/addFactura';
            this.factura.BILL_ID = null;
            if (this.dataService.tipo === 'editar') {
            metodo = 'factura/updateFactura';
            this.factura.BILL_ID = this.dataService.id;
            }
            this.factura.CUSTOMER_ID = this.idCliente;
            this.factura.COMMENTS = this.commentsControl.value;
            this.factura.BILL_STATUS_ID = 1;
            const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
            const idOrganizacion = usuarioSession.ORGANIZATION_ID;
            this.factura.ORGANIZATION_ID = idOrganizacion;
            this.factura.idDocuments = this.idDocuments;
            if (this.impuestos > 0) {
                this.factura.IVA_FACTOR = this.IVA_FIJO;
            }
            this.factura.SUBTOTAL_BEFORE_TAX = this.subtotal;
            this.factura.TOTAL_IVA = this.impuestos;
            this.factura.TOTAL_TAX = 0;

            // Sustitución: facturas previas relacionadas (CFDI Relacionados, TipoRelacion 04)
            let documentos: FacturaDocumento[] = [];
            if (this.sustituye && this.idsDocumentosRelacionados !== null && this.idsDocumentosRelacionados.length > 0) {
                this.factura.RELATION_TYPE_SAT_ID = this.relationTypeSat04Id;
                for (let i = 0; i < this.idsDocumentosRelacionados.length; i++) {
                    const doc = this.listaDocumentoRelacionar.find((p) => p.BILL_ID === this.idsDocumentosRelacionados[i]);
                    if (doc !== undefined && doc !== null) {
                        documentos.push({ BILL_ID: doc.BILL_ID, RELATED_BILL_ID: doc.BILL_ID, UUID: doc.UUID });
                    }
                }
            } else {
                this.factura.RELATION_TYPE_SAT_ID = null;
            }

            const params = {
                factura: this.factura,
                facturaDetalle: this.listaFacturaDetalleAAgregar,
                documentos: documentos
               // tipoFactura:this.TipoFactura
            };

            this._generalService.metodoCallParams(params, metodo).subscribe(
                (result) => {
                this.dataService.guardado = true;

                if(this.dataService.tipo === 'editar'){
                    this._generalService.toastCall('El registro se modificó exitosamente!');
                } else {
                    this.dataService.tipo = 'editar';
                    this.factura.BILL_ID = +result.data;
                    this.dataService.id = +result.data;
                    this.id = this.dataService.id;
                    this.getFactura(this.dataService.id);
                    this.getFacturaDetalle(this.dataService.id);
                    this._generalService.toastCall('El registro se agregó exitosamente!');

                }
                this.btnGuardar = false;
                // this.cerrarModal();
                },
                (error) => {
                const errorMsj =  error as any;
                console.log(errorMsj);
                }
            );
        }
    }

    validarGuardar() {
       /* if (!this.facturaAgregar.controls['sucursal'].valid) {
            this._generalService.toastCall('La Sucursal es requerida');
            this.facturaAgregar.controls['sucursal'].markAsTouched();
            return false;
        } */
        if (!this.facturaAgregar.controls['regimenFiscal'].valid) {
            this._generalService.toastCall('El Regimen Fiscal es requerido');
            this.facturaAgregar.controls['regimenFiscal'].markAsTouched();
            return false;
        }
        if (!this.facturaAgregar.controls['nombre'].valid) {
            this._generalService.toastCall('El Nombre es requerido');
            this.facturaAgregar.controls['nombre'].markAsTouched();
            return false;
        }
        if (!this.facturaAgregar.controls['rfc'].valid) {
            this._generalService.toastCall('El RFC es requerido');
            this.facturaAgregar.controls['rfc'].markAsTouched();
            return false;
        }
        if(this.factura.TipoFactura == false){
            if (!this.facturaAgregar.controls['formaPago'].valid) {
                this._generalService.toastCall('La Forma de Pago es requerida');
                this.facturaAgregar.controls['formaPago'].markAsTouched();
                return false;
            }
            if (!this.facturaAgregar.controls['metodoPago'].valid) {
                this._generalService.toastCall('El Metodo de Pago es requerido');
                this.facturaAgregar.controls['metodoPago'].markAsTouched();
                return false;
            }

            if (!this.facturaAgregar.controls['cfdi'].valid) {
                this._generalService.toastCall('El Uso CFDI es requerido');
                this.facturaAgregar.controls['cfdi'].markAsTouched();
                return false;
            }
         }
        // if (!this.facturaAgregar.controls['cfdi'].valid) {
        //     this._generalService.toastCall('El Uso CFDI es requerido');
        //     this.facturaAgregar.controls['cfdi'].markAsTouched();
        //     return false;
        // }

        let cantidadAguardar = 0;
        let index = 0;
        let falloGrid = false;
        let stringError = '';
        this.listaFacturaDetalleAAgregar.forEach((element) => {
            index++;
            if (element.isChecked) {
                if (element.UNIT_MEASURE_ID === null || element.UNIT_MEASURE_ID === undefined ) {
                   // this._generalService.toastCall('La Unidad es requerida, error en el renglón ' + index);
                    stringError += 'Error Renglón ' + index + ' La Unidad es requerida, ';
                    falloGrid = true;
                }
                if (element.ITEM_SAT_ID === null || element.ITEM_SAT_ID === undefined ) {
                    // this._generalService.toastCall('La Unidad es requerida, error en el renglón ' + index);
                     stringError += 'Error Renglón ' + index + ' La Cve. Prod. o Servicio es requerida, ';
                     falloGrid = true;
                 }
                if (element.DOCUMENT_DETAIL_ID !== null &&  element.totalFaltante !== null && (element.QUANTITY > element.totalFaltante)) {
                    stringError +=  'Error Renglón ' + index +  ' La cantidad sobrepaso al limite de la venta (Maximo ' + (element.totalFaltante) + '), ';
                   // this._generalService.toastCall('La cantidad sobrepaso al limite de la venta (Maximo ' + (element.totalFaltante) + '), error en el renglón ' + index);
                    falloGrid = true;
                } 
                cantidadAguardar++;
            }
        });

        if (falloGrid) {
            this._generalService.toastCall(stringError);
            return false;
        }
        if (cantidadAguardar > 0) {
            if(!falloGrid){
                return true;
            } 
        } else {
            this._generalService.toastCall('Debe de activar por lo menos un renglón.');
            return false;
        }

    }

    validarForm() {
        /* if (!this.facturaAgregar.controls['sucursal'].valid) {
             this._generalService.toastCall('La Sucursal es requerida');
             this.facturaAgregar.controls['sucursal'].markAsTouched();
             return false;
         } */
         if (!this.facturaAgregar.controls['regimenFiscal'].valid) {
             this._generalService.toastCall('El Regimen Fiscal es requerido');
             this.facturaAgregar.controls['regimenFiscal'].markAsTouched();
             return false;
         }
         if (!this.facturaAgregar.controls['nombre'].valid) {
             this._generalService.toastCall('El Nombre es requerido');
             this.facturaAgregar.controls['nombre'].markAsTouched();
             return false;
         }
         if (!this.facturaAgregar.controls['rfc'].valid) {
             this._generalService.toastCall('El RFC es requerido');
             this.facturaAgregar.controls['rfc'].markAsTouched();
             return false;
         }
         if(this.factura.TipoFactura == false){
            if (!this.facturaAgregar.controls['formaPago'].valid) {
                this._generalService.toastCall('La Forma de Pago es requerida');
                this.facturaAgregar.controls['formaPago'].markAsTouched();
                return false;
            }
            if (!this.facturaAgregar.controls['metodoPago'].valid) {
                this._generalService.toastCall('El Metodo de Pago es requerido');
                this.facturaAgregar.controls['metodoPago'].markAsTouched();
                return false;
            }
            if (!this.facturaAgregar.controls['cfdi'].valid) {
                this._generalService.toastCall('El Uso CFDI es requerido');
                this.facturaAgregar.controls['cfdi'].markAsTouched();
                return false;
            }
         }
         
        //  if (!this.facturaAgregar.controls['cfdi'].valid) {
        //      this._generalService.toastCall('El Uso CFDI es requerido');
        //      this.facturaAgregar.controls['cfdi'].markAsTouched();
        //      return false;
        //  }
        

         return true;

     }


    setearSAT(event: any, index: number) {
        if (event !== undefined && event !== null) {
            
                const producto = this.listaProducto.find((element) => element.ITEM_ID === event.value);
                var ivaValor = 0;
                var valor = 0;
                this.cuentaPredialControl.reset();
                if(producto.TYPE == 'A'){
                    //hacemos que cuenta cuentaPredialControl sea requerido
                    // this.cuentaPredialControl.setValidators([Validators.required]);
                    // this.cuentaPredialControl.updateValueAndValidity();
                    this.validarCuentaPredial = false;
                }else{
                    // this.cuentaPredialControl.clearValidators();
                    // this.cuentaPredialControl.updateValueAndValidity();
                    this.validarCuentaPredial = true;
                }
                if(this.factura.TipoFactura){
                    this.valorControl.setValue(0);
                    this.aplicaIVAControl.setValue(false);
                    this.aplicaIVAControl.disable();
                    this.importeIVAControl.setValue(0);
                    this.totalControl.setValue(0);
                    this.totalControl.disable();

                }else{
                    if(!this.containsTaxGeneral){
                        ivaValor = (producto.BASE_SALE_PRICE * .16);
                        valor = producto.BASE_SALE_PRICE;
                        this.valorControl.setValue(valor.toFixed(6));
                    }
                    else
                    {
                        ivaValor = (producto.BASE_SALE_PRICE * 16) / 116;
                        valor = producto.BASE_SALE_PRICE - (ivaValor);
                        this.valorControl.setValue(valor.toFixed(6));
                    }
                    this.aplicaIVAControl.setValue(true);
                    this.importeIVAControl.setValue(ivaValor.toFixed(6));

                    if (this.ventaDetalleListado.length === 0 || this.listaFacturaDetalle[index].DOCUMENT_ID === null
                        || this.listaFacturaDetalle[index].DOCUMENT_ID === undefined) {
                            this.cantidadControl.setValue(1);
                            if(!this.containsTaxGeneral){
                                this.totalControl.setValue((producto.BASE_SALE_PRICE + ivaValor).toFixed(6));
                            }
                            else
                            {
                                this.totalControl.setValue(producto.BASE_SALE_PRICE);
                            }
                        }
                }
                
                // Setear si existe ID SAT
                if (producto.ITEM_SAT_ID !== null) {
                    this.productoSATControl.setValue(producto.ITEM_SAT_ID);

                    /***************************INFINITE SELECT**********************************/
                    const index = this.listaSATCode.findIndex(x => x.itemSATcodeId == producto.ITEM_SAT_ID);
                    var a = this.listaSATCode.splice(index,1);
                    this.listaSATCode.unshift(a[0]);
                    this.itemsShowSat = 10;
                    this.viewDataSat = this.listaSATCode.slice(0, 10);
                    /***************************INFINITE SELECT**********************************/
   
                } else {
                    this.productoSATControl.reset();
                }
                if (producto.BILL_UNIT_MEASURE_ID !== null) {
                    this.unidadControl.setValue(producto.BILL_UNIT_MEASURE_ID);
                } else {
                    this.unidadControl.reset();
                }
                this.descripcionControl.setValue(producto.NAME);
               // this.importeControl.setValue(producto.BASE_SALE_PRICE);

        } else {
            this.productoSATControl.reset();
            this.unidadControl.reset();
           // this.importeControl.reset();
            this.valorControl.reset();
            this.cantidadControl.reset();
            this.descripcionControl.reset();
            this.aplicaIVAControl.reset(true);
            this.importeIVAControl.reset();
            this.totalControl.reset();
            this.cuentaPredialControl.reset();
        }
      //  this.calcularTotalRow();
      
    }
    
    setearIVA(event: any) {
        if (event.checked) {
            this.importeIVAControl.setValue((this.totalControl.value * 16) / 116);
            this.importeIVAControl.setValue(parseFloat(this.importeIVAControl.value.toFixed(6)));
            const valorUnitario = ((this.totalControl.value - this.importeIVAControl.value) / this.cantidadControl.value);
            this.valorControl.setValue(parseFloat(valorUnitario.toFixed(6))); 
 
        } else {
            const valorUnitario = ((this.totalControl.value) / this.cantidadControl.value);
            this.valorControl.setValue(parseFloat(valorUnitario.toFixed(6))); 
            this.importeIVAControl.reset();
            this.importeIVAControl.disable();
        }
       // this.calcularValorUnitario(this.totalControl.value, null);
    }

    /*calcularCantidad(importe: any, facturaDetalle: FacturaDetalle) {
        if (importe !== null && importe !== undefined) {

            const producto = this.listaProducto.find((element) => element.ITEM_ID === this.productoControl.value);
            const cantidad = Math.trunc(this.importeControl.value / producto.BASE_SALE_PRICE);
            this.cantidadControl.setValue(cantidad);

            if (this.aplicaIVAControl.value) {
                this.importeIVAControl.setValue(this.importeControl.value * this.IVA_FIJO);
            }
        } else {
            if (this.aplicaIVAControl.value) {
                this.importeIVAControl.reset();
            }
            this.cantidadControl.reset();
        }
        this.calcularTotalRow();
    }*/

    calcularValorUnitario2(cantidad: any, facturaDetalle: FacturaDetalle) {
        if (cantidad !== null && cantidad !== undefined) {

            if ((this.productoControl.value === null || this.productoControl.value === undefined)
                && this.totalControl.value !== null && this.totalControl.value !== undefined) {
                this.importeIVAControl.setValue((this.totalControl.value * 16) / 116);
                this.importeIVAControl.setValue(parseFloat(this.importeIVAControl.value.toFixed(6)));
            }
            if (this.totalControl.value !== null && this.totalControl.value !== undefined) {

                //Si los productos manejan precios sin iva en el catálogo
                if(!this.containsTaxGeneral){
                    if (this.aplicaIVAControl.value) {
                            this.importeIVAControl.setValue((this.valorControl.value * this.cantidadControl.value) * this.IVA_FIJO);
                            this.importeIVAControl.setValue(parseFloat(this.importeIVAControl.value.toFixed(6)));

                            var totalControlVar = ((this.cantidadControl.value * this.valorControl.value ) +  this.importeIVAControl.value);
                            this.totalControl.setValue(parseFloat(totalControlVar.toFixed(6)));
                            //const valorUnitario = ((this.totalControl.value  - this.importeIVAControl.value));// / this.cantidadControl.value);
                            //this.valorControl.setValue(parseFloat(valorUnitario.toFixed(2)));

                            //this.cantidadControl.value
                            //this.totalControl.value
                            //this.importeIVAControl.setValue((valorUnitario * this.cantidadControl.value) * this.IVA_FIJO);
                            //this.importeIVAControl.setValue(parseFloat(this.importeIVAControl.value.toFixed(2)));

                        } else {
                            const valorUnitario = this.totalControl.value;// / this.cantidadControl.value;
                            this.valorControl.setValue(parseFloat(valorUnitario.toFixed(6)));
                        }
                }
                //Si los productos manejan precios con iva en el catálogo
                else
                {
                    if (this.aplicaIVAControl.value) {
                        // this.importeIVAControl.setValue(this.totalControl.value - ((this.valorControl.value * this.cantidadControl.value) * this.IVA_FIJO));
                            //const valorUnitario = ((this.totalControl.value  - this.importeIVAControl.value));// / this.cantidadControl.value);
                            //this.valorControl.setValue(parseFloat(valorUnitario.toFixed(2)));

                            //agregado
                            this.importeIVAControl.setValue((this.valorControl.value * this.cantidadControl.value) * this.IVA_FIJO);
                            this.importeIVAControl.setValue(parseFloat(this.importeIVAControl.value.toFixed(6)));

                            var totalControlVar = ((this.cantidadControl.value * this.valorControl.value ) +  this.importeIVAControl.value);
                            this.totalControl.setValue(parseFloat(totalControlVar.toFixed(6)));

                        } else {
                            const valorUnitario = this.totalControl.value;// / this.cantidadControl.value;
                            this.valorControl.setValue(parseFloat(valorUnitario.toFixed(6)));
                        }
                }
            }

        } else {
            if (this.aplicaIVAControl.value) {
                this.importeIVAControl.reset();
            }
            this.valorControl.reset();
        }
      //  this.calcularTotalRow();
    }


    calcularValorUnitario(importe: any, facturaDetalle: FacturaDetalle) {
        if (importe !== null && importe !== undefined) {
            
            if (this.aplicaIVAControl.value) {
               
                const valorUnitario = ((this.totalControl.value / 1.16) / this.cantidadControl.value);
                this.importeIVAControl.setValue((valorUnitario * this.cantidadControl.value) * this.IVA_FIJO);
                this.importeIVAControl.setValue(parseFloat(this.importeIVAControl.value.toFixed(6)));
                this.valorControl.setValue(parseFloat(valorUnitario.toFixed(6)));
            } else {
                const valorUnitario = this.totalControl.value / this.cantidadControl.value;
                this.valorControl.setValue(parseFloat(valorUnitario.toFixed(6)));
            }

        } else {
            if (this.aplicaIVAControl.value) {
                this.importeIVAControl.reset();
            }
            this.valorControl.reset();
        }
      //  this.calcularTotalRow();
    }

  /*  calcularTotalRow() {
        if (this.importeControl.value !== null &&  this.importeControl.value !== undefined ) {
            if (this.importeIVAControl.value !== null &&  this.importeIVAControl.value !== undefined ) {
                this.totalControl.setValue(this.importeControl.value + this.importeIVAControl.value);
            } else {
                this.totalControl.setValue(this.importeControl.value);
            }
        } else {
            this.totalControl.setValue(0);
        }
    }*/

    calcularTotal() {
        // SubTotal Impuestos Total
        let sumaSubtotal = 0;
        let sumaImpuestos = 0;
        let sumaTotal = 0;
        for (let i = 0; i < this.listaFacturaDetalle.length; i++) {
            if (this.listaFacturaDetalle[i].isChecked) {
                sumaSubtotal += +this.listaFacturaDetalle[i].AMOUNT;
                sumaImpuestos += (this.listaFacturaDetalle[i].IVA_AMOUNT !== null && this.listaFacturaDetalle[i].IVA_AMOUNT !== undefined) ? +this.listaFacturaDetalle[i].IVA_AMOUNT : 0.00;
                sumaTotal += +this.listaFacturaDetalle[i].total;
            }
        }

        if(!this.containsTaxGeneral){
            this.subtotal = +sumaSubtotal.toFixed(2);
            this.impuestos = +sumaImpuestos.toFixed(2);
            this.total = ((this.subtotal + this.impuestos) - this.impuestosRetenidosTotal);
        }
        else
        {
            var nuevoCalculo = 0;
            nuevoCalculo = sumaSubtotal;

            this.subtotal = +nuevoCalculo.toFixed(2);
            this.impuestos = +sumaImpuestos.toFixed(2);
            this.total = ((this.subtotal + this.impuestos) - this.impuestosRetenidosTotal);
        }
    }

    activarRow(element, event) {
        const index = this.listaFacturaDetalle.findIndex((obj) => obj.index === element.index);
        if (event.checked) {
            this.listaFacturaDetalleAAgregar[index].isChecked = true;

        } else {
           /* if (element.BILL_DETAIL_ID !== null && element.BILL_DETAIL_ID !== undefined) {
                // this.listaFacturaDetalle[index].isChecked = false;
                 this.eliminarFacturaDetalle(this.listaFacturaDetalle[index]);
            } else {
                this.eliminar(element.index);
            } */
            this.listaFacturaDetalleAAgregar[index].isChecked = false;
        }
        this.calcularTotal();
    }

    eliminarRow(element) {
        const index = this.listaFacturaDetalle.findIndex((obj) => obj.index === element.index);
        if (element.BILL_DETAIL_ID !== null && element.BILL_DETAIL_ID !== undefined) {
            // this.listaFacturaDetalle[index].isChecked = false;
            this.eliminarFacturaDetalle(this.listaFacturaDetalle[index]);
        } else {
            this.eliminar(element.index);
        }

    }

    // fetchMoreProd() {
    //     if(this.itemsShowProd < this.listaProducto.length) {
    //         this.itemsShowProd += 10;
    //         this.viewDataProd = this.listaProducto.slice(0, this.itemsShowProd);
    //     }
    // }

    fetchMoreProd() {
        let arr: any[];

        // si está filtrado (usuario escribió algo)
        if (this.isFilteredProd && this.arrayFilteredProd) {
            this.filteredItemsShowProd += 10;
            arr = this.arrayFilteredProd.slice(0, this.filteredItemsShowProd);
        } else {
            // sin filtro
            this.itemsShowProd += 10;
            arr = this.listaProducto.slice(0, this.itemsShowProd);
        }

        // respeta si estás editando o agregando
        if (this.seEstaEditando) {
            this.viewDataProdEdit = arr;
        } else {
            this.viewDataProd = arr;
        }
    }

    fetchMoreSat() {
      if(this.itemsShowSat < this.listaSATCode.length) {
        this.itemsShowSat += 10;
        this.viewDataSat = this.listaSATCode.slice(0, this.itemsShowSat);
      }  
    }

    resetProd() {
        this.itemsShowProd = 10;
        this.viewDataProd = this.listaProducto.slice(0, this.itemsShowProd);
    }

    resetSat() {
        this.itemsShowSat = 10;
        this.viewDataSat = this.listaSATCode.slice(0, this.itemsShowSat);
    }

    // onKeyUpProd(val: any) {
    //     let arr: any[];
    //     if (val.currentTarget.value != "") {
    //       this.arrayFilteredProd = this.listaProducto.filter((obj) => {
    //         return obj.NAME.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1;
    //       })

    //       arr = this.arrayFilteredProd.slice(0, this.filteredItemsShowProd);
    //       this.isFilteredProd = true;
    //     } else {
    //       /***************************INFINITE SELECT**********************************/
    //       // arr = this.filtroSATCodes;
    //       this.isFilteredProd = false;
    //       this.filteredItemsShowProd = 10;
    //       this.arrayFilteredProd = undefined;
    //       arr = this.listaProducto.slice(0, this.itemsShowProd);
    //       /***************************INFINITE SELECT**********************************/
    //     }
    //     /***************************INFINITE SELECT**********************************/
    //     if(this.seEstaEditando) {
    //         this.viewDataProdEdit = arr;
    //     } else {
    //         this.viewDataProd = arr;
    //     }
    //     /***************************INFINITE SELECT**********************************/
    // }

    // onKeyUpProd(val: any) {
    //     const term = ((val.currentTarget.value || '') + '').trim().toLowerCase();

    //     let arr: any[];

    //     if (term !== '') {
    //         this.arrayFilteredProd = this.listaProducto.filter((obj) => {
    //             const name = (obj.NAME || '').toString().toLowerCase();
    //             const sku = (obj.SKU || '').toString().toLowerCase();

    //             return name.indexOf(term) > -1 || sku.indexOf(term) > -1;
    //         });

    //         this.filteredItemsShowProd = 10; // reinicia a 10 al cambiar término
    //         arr = this.arrayFilteredProd.slice(0, this.filteredItemsShowProd);
    //         this.isFilteredProd = true;
    //     } else {
    //         this.isFilteredProd = false;
    //         this.filteredItemsShowProd = 10;
    //         this.itemsShowProd = 10;
    //         this.arrayFilteredProd = undefined;

    //         arr = this.listaProducto.slice(0, this.itemsShowProd);
    //     }

    //     if (this.seEstaEditando) {
    //         this.viewDataProdEdit = arr;
    //     } else {
    //         this.viewDataProd = arr;
    //     }
    // }

    onKeyUpProd(val: any) {
        const termRaw = (val.currentTarget.value || '');
        const tokens = this.tokenize(termRaw);

        let arr: any[];

        if (tokens.length) {
            this.arrayFilteredProd = this.listaProducto.filter((p: any) => {
                const haystack = this.normalizeText(`${p.SKU || ''} ${p.NAME || ''}`);

                // AND: todas las palabras deben aparecer
                return tokens.every(t => haystack.includes(t));
            });

            this.filteredItemsShowProd = 10;
            arr = this.arrayFilteredProd.slice(0, this.filteredItemsShowProd);
            this.isFilteredProd = true;
        } else {
            this.isFilteredProd = false;
            this.filteredItemsShowProd = 10;
            this.itemsShowProd = 10;
            this.arrayFilteredProd = undefined;

            arr = this.listaProducto.slice(0, this.itemsShowProd);
        }

        if (this.seEstaEditando) this.viewDataProdEdit = arr;
        else this.viewDataProd = arr;
    }

    private normalizeText(s: any): string {
        return (s ?? '')
            .toString()
            .toLowerCase()
            .normalize('NFD')                 // quita acentos
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9\s-]/g, ' ')    // quita signos raros (deja letras, num, espacios, guión)
            .replace(/\s+/g, ' ')
            .trim();
    }

    private tokenize(s: string): string[] {
        return this.normalizeText(s)
            .split(' ')
            .filter(t => t.length >= 2);      // ignora tokens muy cortos (ajusta si quieres)
    }

    onKeyUpSat(val: any) {
        let arr: any[];
        if (val.currentTarget.value != "") {
          this.arrayFilteredSat = this.listaSATCode.filter((obj) => {
            return obj.SATcode.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1 || 
            obj.DESCRIPTION.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1;
          })

          arr = this.arrayFilteredSat.slice(0, this.filteredItemsShowSat);
          this.isFilteredSat = true;
        } else {
          /***************************INFINITE SELECT**********************************/
          // arr = this.filtroSATCodes;
          this.isFilteredSat = false;
          this.filteredItemsShowSat = 10;
          this.arrayFilteredSat = undefined;
          arr = this.listaSATCode.slice(0, this.itemsShowSat);
          /***************************INFINITE SELECT**********************************/
        }
        /***************************INFINITE SELECT**********************************/
        if(this.seEstaEditando) {
            this.viewDataSatEdit = arr;
        } else {
            this.viewDataSat = arr;
        }
        /***************************INFINITE SELECT**********************************/
    }

    /***************************INFINITE SELECT**********************************/
    registerPanelScrollEvent() {
        const panel = this.selectElem.panel.nativeElement;
        panel.addEventListener('scroll', event => this.loadAllOnScroll(event));
    }

    loadAllOnScroll(event) {
        if (event.target.scrollTop === (event.target.scrollHeight - event.target.offsetHeight)) {
          if(this.isFilteredProd) {
            if(this.filteredItemsShowProd < this.arrayFilteredProd.length) {
                this.filteredItemsShowProd += 10;
                if(this.seEstaEditando) {
                    this.viewDataProdEdit = this.arrayFilteredProd.slice(0, this.filteredItemsShowProd);
                } else {
                    this.viewDataProd = this.arrayFilteredProd.slice(0, this.filteredItemsShowProd);
                }
            }
          } else {
            if(this.seEstaEditando) {
                if(this.itemsShowProd < this.listaProductoEdit.length) {
                    this.itemsShowProd += 10;
                    this.viewDataProdEdit = this.listaProductoEdit.slice(0, this.itemsShowProd);
                }
            } else {
                if(this.itemsShowProd < this.listaProducto.length) {
                    this.itemsShowProd += 10;
                    this.viewDataProd = this.listaProducto.slice(0, this.itemsShowProd);
                }
            }            
          }
        }
    }

    registerPanelScrollEventSat() {
        const panelsat = this.selectElemSat.panel.nativeElement;
        panelsat.addEventListener('scroll', event => this.loadAllOnScrollSat(event));
    }

    loadAllOnScrollSat(event) {
        if (event.target.scrollTop === (event.target.scrollHeight - event.target.offsetHeight)) {
          if(this.isFilteredSat) {
            if(this.filteredItemsShowSat < this.arrayFilteredSat.length) {
                this.filteredItemsShowSat += 10;
                if(this.seEstaEditando) {
                    this.viewDataSatEdit = this.arrayFilteredSat.slice(0, this.filteredItemsShowSat);
                } else {
                    this.viewDataSat = this.arrayFilteredSat.slice(0, this.filteredItemsShowSat);
                }
            }
          } else {
            if(this.seEstaEditando) {
                if(this.itemsShowSat < this.listaSATCodeEdit.length) {
                    this.itemsShowSat += 10;
                    this.viewDataSatEdit = this.listaSATCodeEdit.slice(0, this.itemsShowSat);
                }
            } else {
                if(this.itemsShowSat < this.listaSATCode.length) {
                    this.itemsShowSat += 10;
                    this.viewDataSat = this.listaSATCode.slice(0, this.itemsShowSat);
                }
            }            
          }
        }
    }
    /***************************INFINITE SELECT**********************************/
    consultarDataCompany(){
        if(this.dataService.factura.idCliente != null || this.dataService.factura.idCliente != undefined ){
       
            this.facturaAgregar.controls['cfdi'].setValue(3); // Gastos Generales
        }

        let metodo = 'factura/getDataCompany';
        const params = { 
            loacs: sessionStorage.getItem('acslo'),
        };

        this._generalService.metodoCallParams(params, metodo).subscribe(
            (result) => {
                const tableResult = JSON.parse(result);
                this.listaDataCompany = tableResult.Table;
                this.listaPredial = tableResult.Table1;
            },
            (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj);
            }
        );
    }

    onChangeTipoFactura(event: any){
        //console.log(event);
        let tipoFactura = event;

        if (tipoFactura == 'T'){
            this.facturaAgregar.controls['regimenFiscal'].setValue(this.listaDataCompany[0]['BILL_TAX_REGIME_ID']);
            this.facturaAgregar.controls['nombre'].setValue(this.listaDataCompany[0]['NAME']);
            this.facturaAgregar.controls['rfc'].setValue(this.listaDataCompany[0]['RFC']);

            this.facturaAgregar.controls['formaPago'].reset();
            this.facturaAgregar.controls['metodoPago'].reset();
            this.facturaAgregar.controls['formaPago'].disable();
            this.facturaAgregar.controls['metodoPago'].disable();

            this.listaCFDI;

            this.facturaAgregar.controls['cfdi'].setValue(23); // Sin efectos fiscales
            this.facturaAgregar.controls['cfdi'].disable();


            this.factura.TipoFactura = true;
            
          
           
        }else if (tipoFactura == 'I' || tipoFactura == 'IC'){
            this.factura.TipoFactura = false;

            if(this.dataService.factura.idCliente == null || this.dataService.factura.idCliente == undefined ){
                this._generalService.toastCall('El cliente es requerido!');
            setTimeout(() => {
                this.dataService.dialogRef.close();
            }, 100);


            }else{
                //this.facturaAgregar.controls['cfdi'].setValue(3); // Gastos Generales
                if (!this.facturaAgregar.controls['cfdi'].value) {
                    this.facturaAgregar.controls['cfdi'].setValue(3); // Gastos Generales
                }
                //this.factura.TipoFactura = false;
            }
        } 
    }
    
    impuestosRetenidos(element){
        //console.log("Abro Impuestos Retenidos")

        let dialogPrincipal = this.dataService.dialogRef;
        let baseFactura = element.total;
        let indexFactura = element.index;
        let impuestosRetenidosEdit =  this.listaFacturaDetalleAAgregar[indexFactura]
        let id_billDetail = element.BILL_DETAIL_ID
        const dialogRef = this.dialog.open(modalImpuestosRetendidos, {
            disableClose: true, 
            width:'85%', 
            height:'50%',
            panelClass: 'full-width-dialog',
            data: {
                BILL_DETAIL_ID:id_billDetail,
                baseFactura: baseFactura,
                indexFactura:indexFactura,
                impuestosRetenidosEdit:impuestosRetenidosEdit,
            }
        });

        //abre modal
        this.dataService.dialogRef = dialogRef; 

        dialogRef.afterClosed().subscribe((result) => {
            this.dataService.dialogRef = dialogPrincipal
            //params impuestos retenidos
            const tableResult = result;
            this.DataImpuestosRetenidos = tableResult
            
            this.addImpuestosRetenidos();
            this.calcularImpuestosRetenidos();
        });
    }
    //add Impuestos retenidos al detalle
    addImpuestosRetenidos(){
        this.listaFacturaDetalleAAgregar
        this.DataImpuestosRetenidos

        if(this.DataImpuestosRetenidos !== undefined){
            let indexFactura = this.DataImpuestosRetenidos.indexFacturaDetalle;

            for (const facturaDetalleAdd of this.listaFacturaDetalleAAgregar) {
                const indexFacturaDetalle = facturaDetalleAdd.index;
        
                // Verificar si el índice de factura coincide con el índice del detalle de factura
                if (indexFactura === indexFacturaDetalle) {
                    // Agregar el objeto DataImpuestosRetenidos al detalle de factura correspondiente
                    facturaDetalleAdd.impuestoRetenido = this.DataImpuestosRetenidos;
                }
            }
        }
        
        this.listaFacturaDetalleAAgregar

    }
    //Calculo total de impuestos Retenidos
    calcularImpuestosRetenidos() {
        this.listaFacturaDetalleAAgregar
        this.listaFacturaDetalle
        this.listaFacturaDetalleImpuestosRetenidos
        

             
   
        // Variable para almacenar la suma total de AMOUNT
        let sumaTotalAmount = 0;

        // Iteramos sobre listaFacturaDetalleAAgregar
        this.listaFacturaDetalleAAgregar.forEach((detalle) => {
            // Verificamos si existe la propiedad impuestoRetenido en el elemento actual
            if (detalle.impuestoRetenido) {
                // Si existe, iteramos sobre impuestosRetenidosData y sumamos los AMOUNT
                detalle.impuestoRetenido.impuestosRetenidosData.forEach((impuesto) => {
                    if (impuesto.AMOUNT !== undefined) {
                        sumaTotalAmount += impuesto.AMOUNT;
                    }
                });
            }
        });

        this.impuestosRetenidosTotal = sumaTotalAmount;

        this. calcularTotal();
    }
   
    
}



// WEBPACK FOOTER //
// ./src/app/factura/agregar-editar/factura-detalle.component.ts